import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";
import swal from "sweetalert";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import Chapter from "./Chapter.js";
import CustomLoader from "../static/CustomLoader.js";
import {
  MasterPage,
  MasterToolbar,
  MasterButton,
  MasterSearch,
  MasterGrid,
  MasterDialog,
  MasterConfirmDialog,
} from "../static/Masterpage";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";

const ChapterListing = () => {
  const apiUrl = localStorage.getItem("apiUrl");
  const dbTokenData = localStorage.getItem("dbTokenData");
  const headers = {
    Authorization: `Bearer ${dbTokenData}`,
    "Content-Type": "application/json",
    dbMaster: "",
  };

  const [loading, setLoading] = useState(false);
  const [chapters, setChapters] = useState([]);
  const [divData, setDivData] = useState([]);
  const [filterData, setFilterData] = useState([{}]);
  const [serach, setSerach] = useState("");
  const [selectedData, setSelectedData] = useState([]);
  const [selectedDatacode, setSelectedDatacode] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [density, setDensity] = useState("standard");
  const [showConfirm, setShowConfirm] = useState(false);
  const [addShow, setAddShow] = useState(false);
  const [editShow, setEditShow] = useState(false);

  const columns = [
    {
      field: "chapter",
      headerName: "Chapter",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "empcodes",
      headerName: "Employees",
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (params.value) {
          const empCount = params.value.split(",").length;
          return `${empCount} employee(s)`;
        }
        return "None";
      },
    },
  ];

  const addHandleShow = () => {
    setAddShow(true);
  };

  const addHandleClose = () => {
    setShowConfirm(true);
  };

  const editHandleShow = () => {
    if (selectedData.length > 1 || selectedData.length === 0) {
      toast.warning("Please Select only one value");
      return;
    }
    setEditShow(true);
  };

  const editHandleClose = () => {
    setShowConfirm(true);
  };

  const handleConfirmClose = () => {
    setShowConfirm(false);
    setAddShow(false);
    setEditShow(false);
  };

  const handleCancelClose = () => {
    setShowConfirm(false);
  };

  const fetchDepartments = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${apiUrl}division`, { headers });

      const data = response.data;

      if (data.cd === 1) {
        toast.error(data.description || "Failed to fetch departments.");
        setDivData([]);
      } else {
        const sectionOption = data.map((op) => ({
          value: op.code,
          label: op.name,
        }));
        setDivData(sectionOption);
      }
    } catch (err) {
      console.error("Fetch error:", err);
      setDivData([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchData = async () => {
    try {
      setLoading(true);

      const response = await axios.get(apiUrl + "chapter", { headers });

      setChapters(response.data);
      setFilterData(response.data);
      setRefresh(false);
      setSelectedData([]);
      setSelectedDatacode([]);
    } catch (error) {
      console.log("error " + error);
      setChapters([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    fetchDepartments();
  }, [refresh]);

  const handlesearch = (event) => {
    const getSearch = event.target.value.toLowerCase();

    if (getSearch.length > 0) {
      const searchdata = filterData.filter((item) =>
        Object.keys(item).some((key) =>
          String(item[key]).toLowerCase().includes(getSearch),
        ),
      );

      setChapters(searchdata);
    } else {
      setChapters(filterData);
    }

    setSerach(getSearch);
  };

  const RemoveFunction = async () => {
    if (selectedData && selectedData.length > 0 && selectedDatacode[0] !== 1) {
      swal({
        title: "Do you want to remove?",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then(async (confirmDelete) => {
        if (confirmDelete) {
          setLoading(true);

          try {
            const response = await axios.delete(
              apiUrl + "chapter/" + selectedData[0],
              { headers },
            );

            if (response.data.cd === 1) {
              toast.error(
                response.data.description || "Failed to delete record.",
              );
            } else {
              toast.success("Record removed successfully.");
              fetchData();
            }
          } catch (error) {
            console.error("Error deleting record:", error);
          } finally {
            setLoading(false);
          }
        }
      });
    } else if (selectedDatacode[0] === 1) {
      toast.warning("General chapter cannot be deleted.");
      setLoading(false);
    } else {
      toast.warning("Please Select at least one value");
      setLoading(false);
    }
  };

  const expectedHeaders = [
    "id",
    "code",
    "chapter",
    "name",
    "description",
    "divcode",
    "empcodes",
  ];

  const exportToExcel = (data, filename = "Chapter.xlsx") => {
    const exportData = data.map((item) => ({
      id: item.id,
      code: item.code,
      chapter: item.chapter,
      name: item.name,
      description: item.description || "",
      divcode: item.divcode,
      empcodes: item.empcodes || "",
    }));

    const ws = XLSX.utils.json_to_sheet(exportData, {
      header: expectedHeaders,
    });

    const wb = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    const excelBuffer = XLSX.write(wb, {
      bookType: "xlsx",
      type: "array",
    });

    const file = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });

    saveAs(file, filename);
  };

  const importFromExcel = (file, onValidData, onError) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const wb = XLSX.read(e.target.result, {
        type: "binary",
      });

      const sheet = wb.Sheets[wb.SheetNames[0]];

      const json = XLSX.utils.sheet_to_json(sheet, {
        defval: "",
      });

      const headers1 = Object.keys(json[0] || {});

      const isValid = expectedHeaders.every((h) => headers1.includes(h));

      if (!isValid) {
        onError(
          "Invalid Excel Format. Please use the correct column headers: " +
            expectedHeaders.join(", "),
        );
      } else {
        let hasError = false;

        json.forEach((row, index) => {
          if (row.empcodes) {
            const empCodesStr = String(row.empcodes).trim();

            if (empCodesStr && !/^(\d+)(,\d+)*$/.test(empCodesStr)) {
              onError(
                `Invalid employee codes format in row ${
                  index + 2
                }. Use comma-separated numbers (e.g., 101,102,103)`,
              );

              hasError = true;
            }
          }
        });

        if (!hasError) {
          onValidData(json);
        }
      }
    };

    reader.readAsBinaryString(file);
  };

  const handleSubmitWithImportedData = async (importedData) => {
    if (importedData.length > 0) {
      setLoading(true);

      try {
        const transformedData = importedData.map((item) => ({
          ...item,
          id: 0,
          code: 0,
          divcode: item.divcode || 0,
          empcodes: item.empcodes || "",
        }));

        const response = await axios.post(
          apiUrl + "chapter/multipleSave",
          transformedData,
          { headers },
        );

        if (response.data.cd === 1) {
          toast.warning("Failed to Import Data.");
          setRefresh(true);
        } else {
          toast.success("Imported data saved successfully.");
          setRefresh(true);
        }
      } catch (error) {
        console.error("Error during import:", error);
        toast.error("Error during import.");
      } finally {
        setLoading(false);
      }
    } else {
      toast.warning("No data to import.");
    }
  };

  const handleExcelImport = (event) => {
    const file = event.target.files[0];

    if (file) {
      importFromExcel(
        file,
        (validData) => {
          handleSubmitWithImportedData(validData);
          toast.success("Valid Excel file imported.");
        },
        (errorMsg) => {
          toast.error(errorMsg);
        },
      );
    }

    event.target.value = null;
  };

  return (
    <>
      <MasterPage>
        <MasterToolbar
          actions={
            <>
              <MasterButton
                variant="add"
                tooltip="Create new Chapter"
                onClick={addHandleShow}
                disabled={loading}
              >
                Add
              </MasterButton>

              <MasterButton
                variant="update"
                tooltip="Edit Selected Chapter"
                onClick={editHandleShow}
                disabled={loading}
              >
                Update
              </MasterButton>

              <MasterButton
                variant="danger"
                tooltip="Delete Selected Chapter"
                onClick={RemoveFunction}
                disabled={loading}
              >
                Delete
              </MasterButton>

              <MasterButton
                variant="outline"
                tooltip="Export Chapter data to Excel"
                onClick={() => exportToExcel(chapters)}
                disabled={loading}
              >
                Export
              </MasterButton>

              <MasterButton
                variant="outline"
                tooltip="Import Chapter data from Excel"
                component="label"
                icon={<UploadFileOutlinedIcon />}
                disabled={loading}
              >
                Import Data
                <input
                  type="file"
                  accept=".xlsx, .xls"
                  hidden
                  onChange={handleExcelImport}
                />
              </MasterButton>
            </>
          }
          search={
            <MasterSearch
              tooltip="Search by All"
              value={serach}
              onChange={handlesearch}
              inputRef={(input) => input && input.focus()}
            />
          }
        />

        <MasterGrid
          density={density}
          onDensityChange={(newDensityString) => setDensity(newDensityString)}
          rows={
            chapters !== null &&
            chapters.length > 0 &&
            Object.keys(chapters[0]).length !== 0 &&
            chapters
          }
          columns={columns}
          onSelectionModelChange={(selectedIds) => {
            const selectedRows = chapters.filter((row) =>
              selectedIds.includes(row.id),
            );

            const selectedIdsArray = selectedRows.map((row) => row.id);

            const selectedCodesArray = selectedRows.map((row) => row.code);

            setSelectedData(selectedIdsArray);
            setSelectedDatacode(selectedCodesArray);
          }}
        />
      </MasterPage>

      {loading && <CustomLoader />}

      <MasterDialog
        open={addShow}
        onHide={addHandleClose}
        title="Add Chapter"
        maxWidth="md"
      >
        <Chapter
          selectedId=""
          mode="A"
          onHide={addHandleClose}
          setRefresh={setRefresh}
          divData={divData}
        />
      </MasterDialog>

      <MasterDialog
        open={editShow}
        onHide={editHandleClose}
        title="Edit Chapter"
        maxWidth="md"
      >
        <Chapter
          selectedId={selectedData && selectedData[0]}
          mode="U"
          onHide={editHandleClose}
          setRefresh={setRefresh}
          divData={divData}
        />
      </MasterDialog>

      <MasterConfirmDialog
        show={showConfirm}
        title="Close Confirmation"
        message="Are you sure you want to close this modal?"
        onConfirm={handleConfirmClose}
        onCancel={handleCancelClose}
      />
    </>
  );
};

export default ChapterListing;
